import { type RouteObject } from "react-router";

import Admin from "./admin/Admin";
import { EpostVerifisering } from "./epostVerifsering/EpostVerifisering";
import { EpostVerifiseringFeilet } from "./epostVerifsering/EpostVerifiseringFeilet";
import { EpostVerifiseringFullfort } from "./epostVerifsering/EpostVerifiseringFullfort";
import VerificationPage from "./epostVerifsering/VerificationPage";
import LoginError from "./LoginError/LoginError";
import LoginRedirectWrapper from "./loginRedirectWrapper/LoginRedirectWrapper";
import OAuthErrorPage from "./mobileapp/OAuthErrorPage";
import { OAuthIDportenAuthorize } from "./mobileapp/OAuthIDportenAuthorize";
import { OAuthLogout } from "./mobileapp/OAuthLogout";
import { OAuthPasswordAuthorize } from "./mobileapp/OAuthPasswordAuthorize";
import { OAuthRedirect } from "./mobileapp/OAuthRedirect";
import { OAuthSignicat } from "./mobileapp/OAuthSignicat";
import { OAuthSuccess } from "./mobileapp/OAuthSuccess";
import { OAuthSuccessWithIDportenLogout } from "./mobileapp/OAuthSuccessWithIDportenLogout";
import { CompletePersonLogin } from "./privatperson/CompletePersonLogin";
import PersonLogin from "./privatperson/PersonLogin";
import Logout from "./utlogging/logout";
import Virksomhet from "./virksomhet/Virksomhet";

const appRoutes: RouteObject[] = [
  {
    path: "mobileLogin/:token/signicat",
    element: <OAuthSignicat />,
    errorElement: <OAuthErrorPage />,
  },
  {
    path: "mobileLogin/:token/password",
    element: <OAuthPasswordAuthorize />,
    errorElement: <OAuthErrorPage />,
  },
  {
    path: "mobileLogin/:token/:idportenLevel",
    element: <OAuthIDportenAuthorize shouldKeepIdportenSession={false} />,
    errorElement: <OAuthErrorPage />,
  },
  {
    path: "mobileLogin/:token/:idportenLevel/keepIdportenSessionAfterLogin",
    element: <OAuthIDportenAuthorize shouldKeepIdportenSession={true} />,
    errorElement: <OAuthErrorPage />,
  },
  {
    path: "mobileSuccess/:token",
    element: <OAuthSuccess />,
    errorElement: <OAuthErrorPage />,
  },
  {
    path: "mobileSuccessWithIDportenLogout/:token",
    element: <OAuthSuccessWithIDportenLogout />,
    errorElement: <OAuthErrorPage />,
  },
  {
    path: "mobileRedirect/:redirectUrl",
    element: <OAuthRedirect />,
    errorElement: <OAuthErrorPage />,
  },
  {
    path: "mobileLogout/:redirectUrl",
    element: <OAuthLogout />,
    errorElement: <OAuthErrorPage />,
  },
  {
    path: "complete",
    element: <CompletePersonLogin />,
  },
  {
    element: <VerificationPage />,
    children: [
      { path: "epost-verifisering/", element: <EpostVerifisering /> },
      {
        path: "epost-verifisering/fullfort/",
        element: <EpostVerifiseringFullfort />,
      },
      {
        path: "epost-verifisering/feilet/",
        element: <EpostVerifiseringFeilet />,
      },
    ],
  },
  {
    element: <LoginRedirectWrapper />,
    children: [
      { element: <PersonLogin />, index: true },
      { path: "person/", element: <PersonLogin /> },
      { path: "logout/", element: <Logout timeout={false} /> },
      { path: "timeout/", element: <Logout timeout={true} /> },
      { path: "business/", element: <Virksomhet /> },
      { path: "admin/", element: <Admin /> },
      { path: "loginError/", element: <LoginError /> },
      { path: "innloggingFeilet/", element: <LoginError /> },
    ],
  },
];

export default appRoutes;
